import axios from "axios";
import config from "../config/config";
import router from "../router/router";
import store from "../store";
import Vue from "vue";

const instance = axios.create({
  baseURL: config.baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// const token = localStorage.getItem("token");

// if (token) {
//   instance.defaults.headers.common.Authorization = `Bearer ` + token;
// }

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    const {
      response: {
        status,
        data: { message, error },
      },
    } = err;

    if (status === 400 || status === 403) {
      Vue.toasted.error(message, {
        position: "top-right",
        duration: 5000,
      });
    }
    if (status === 422) {
      error.map((message) =>
        Vue.toasted.error(message, {
          position: "top-right",
          duration: 5000,
        })
      );
    }

    if (status === 403) {
      store.dispatch("logout").then(() => router.push("/login"));
    }

    return Promise.reject(err);
  }
);

export default instance;
